import { render, staticRenderFns } from "./PconAdd.vue?vue&type=template&id=97761176&scoped=true&"
import script from "./PconAdd.vue?vue&type=script&lang=js&"
export * from "./PconAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97761176",
  null
  
)

export default component.exports